
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#141B34","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.667 2.002c-.375.006-.748.021-1.114.045-2.789.186-5.01 2.439-5.193 5.267a13.166 13.166 0 000 1.68c.067 1.03.522 1.984 1.059 2.789.311.564.106 1.268-.219 1.882-.234.443-.35.665-.257.825.094.16.304.165.723.175.83.02 1.39-.214 1.833-.542.252-.186.378-.278.465-.29.086-.01.257.06.599.201.307.127.663.205.99.226.95.063 1.943.064 2.894 0 2.789-.185 5.01-2.438 5.193-5.266.036-.554.036-1.127 0-1.68a5.712 5.712 0 00-.354-1.647","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9.333 4S10 4 10.667 5.333c0 0 2.117-3.333 4-4","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.997 8.333h.006m2.658 0h.006m-5.334 0h.006","stroke-width":"2"}})])])
          )
        }
      }
    